import { render } from "./ModalConfiguracoesUsuario.vue?vue&type=template&id=fa6c6ee6"
import script from "./ModalConfiguracoesUsuario.vue?vue&type=script&lang=js"
export * from "./ModalConfiguracoesUsuario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__